import React from 'react';
export var Ecosystems = function Ecosystems(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", {
    id: "Group_137",
    transform: "translate(-1 -0.999)"
  }, React.createElement("g", {
    id: "Path_319"
  }, React.createElement("path", {
    d: "M25,2C12.3,2,2,12.3,2,25s10.3,23,23,23s23-10.3,23-23S37.7,2,25,2z M25,44C14.5,44,6,35.4,6,25S14.5,6,25,6s19,8.4,19,19\n\t\t\tC44,35.4,35.4,44,25,44z"
  }), React.createElement("path", {
    d: "M25,2c12.7,0,23,10.3,23,23S37.7,48,25,48S2,37.7,2,25S12.3,2,25,2z M25,44c10.4,0,19-8.5,19-19S35.4,6,25,6S6,14.6,6,25\n\t\t\tS14.6,44,25,44z"
  })), React.createElement("g", {
    id: "Path_320",
    transform: "translate(-7.826 -7.826)"
  }, React.createElement("path", {
    d: "M32.8,21.8c-6,0-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11S38.9,21.8,32.8,21.8L32.8,21.8z M32.8,39.8c-3.8,0-7-3.2-7-7\n\t\t\ts3.2-7,7-7s7,3.2,7,7l0,0C39.8,36.7,36.7,39.8,32.8,39.8z"
  }), React.createElement("path", {
    d: "M32.8,21.8c6,0,11,4.9,11,11s-4.9,11-11,11s-11-4.9-11-11S26.8,21.8,32.8,21.8z M32.8,39.8c3.8,0,7-3.2,7-7s-3.2-7-7-7\n\t\t\ts-7,3.2-7,7S29,39.8,32.8,39.8z"
  })), React.createElement("g", {
    id: "Rectangle_48",
    transform: "translate(8.304 8.304)"
  }, React.createElement("rect", {
    id: "fill",
    x: "14.7",
    y: "14.7",
    width: "4",
    height: "4"
  })), React.createElement("g", {
    id: "Rectangle_49",
    transform: "translate(8.304 3.087)"
  }, React.createElement("rect", {
    id: "fill-2",
    x: "14.7",
    y: "4.9",
    width: "4",
    height: "4"
  })), React.createElement("g", {
    id: "Rectangle_50",
    transform: "translate(8.304 13.522)"
  }, React.createElement("rect", {
    id: "fill-3",
    x: "14.7",
    y: "24.4",
    width: "4",
    height: "4"
  })), React.createElement("g", {
    id: "Rectangle_51",
    transform: "translate(13.522 8.304)"
  }, React.createElement("rect", {
    id: "fill-4",
    x: "24.4",
    y: "14.7",
    width: "4",
    height: "4"
  })), React.createElement("g", {
    id: "Rectangle_52",
    transform: "translate(3.087 8.304)"
  }, React.createElement("rect", {
    id: "fill-5",
    x: "4.9",
    y: "14.7",
    width: "4",
    height: "4"
  }))));
};